import { render, staticRenderFns } from "./UserTerm.vue?vue&type=template&id=e519b35c&scoped=true&"
import script from "./UserTerm.vue?vue&type=script&lang=ts&"
export * from "./UserTerm.vue?vue&type=script&lang=ts&"
import style0 from "./UserTerm.vue?vue&type=style&index=0&id=e519b35c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e519b35c",
  null
  
)

export default component.exports